import { canHover } from '@/lib/canHover';
import { TOOLTIP_SHOW_DELAY } from '@/lib/tooltipShowDelay';

export function createTooltip(target: HTMLElement, text: string): { setEnabled: (enabled: boolean) => void } {
  // Note: When element is not in DOM, getComputedStyle returns empty string for position
  const computedStyle = window.getComputedStyle(target);
  if (!computedStyle.position || computedStyle.position === 'static') {
    target.style.position = 'relative';
  }

  const tooltipId = `gladly-tooltip-${Math.random().toString(36).slice(2, 9)}`;

  const tooltip = document.createElement('div');
  tooltip.className = 'gladly-tooltip';
  tooltip.id = tooltipId;
  tooltip.setAttribute('role', 'tooltip');

  const content = document.createElement('div');
  content.className = 'gladly-tooltip-content';
  content.textContent = text;

  const arrow = document.createElement('div');
  arrow.className = 'gladly-tooltip-arrow';

  tooltip.appendChild(content);
  tooltip.appendChild(arrow);
  target.appendChild(tooltip);
  target.setAttribute('aria-describedby', tooltipId);

  let isEnabled = true;
  let showTimeoutId: ReturnType<typeof setTimeout> | null = null;

  target.addEventListener('mouseenter', () => {
    // Touch devices fire a synthetic mouseenter on tap; only show on real hover.
    if (isEnabled && canHover()) {
      showTimeoutId = setTimeout(() => {
        tooltip.classList.add('visible');
      }, TOOLTIP_SHOW_DELAY);
    }
  });

  target.addEventListener('mouseleave', () => {
    if (showTimeoutId) {
      clearTimeout(showTimeoutId);
      showTimeoutId = null;
    }
    tooltip.classList.remove('visible');
  });

  return {
    setEnabled: (enabled: boolean) => {
      isEnabled = enabled;
      if (!enabled) {
        if (showTimeoutId) {
          clearTimeout(showTimeoutId);
          showTimeoutId = null;
        }
        tooltip.classList.remove('visible');
      }
    },
  };
}
